import * as apiCommon from "../apiCommon";
import * as apiUtil from "../apiUtils";
import { CREDIT_CERTIFICATE } from "../../constants/constant_doc_types";

export async function fetchCreditCertificateById(app, id) {
  const params = { id, docType: CREDIT_CERTIFICATE };
  const result = await apiCommon.getDoc(app, params, { assemble_custom_fields: true });
  return result;
}

export async function saveCreditCertificate(app, data) {
  const creditCertificateData = {
    ...data,
    doc_type: CREDIT_CERTIFICATE,
    available_from: apiUtil.toUtcDate(data.available_from),
    available_to: apiUtil.toUtcDate(data.available_to),
    certificate_type_id: data.certificate_type_id,
    subsidiary_id: data.subsidiary.id,
    location_id: data.location_id,
    item: (data.item || {})._id,
    currency_id: data.currency.id,
    amount: apiUtil.toCurrency(data.amount),
    amount_remaining: apiUtil.toCurrency(data.amount_remaining),
    authorisation_code: data.authorisation_code,
    certificate_id: data.certificate_id,
    active: apiUtil.toBoolean(data.active),
    reason_code_id: data.reason_code_id,
    comment: data.comment,
    is_allocated: apiUtil.toBoolean(data.is_allocated),
    custom_fields: data.custom_fields,
  };
  const result = await apiCommon.saveDoc(app, {
    source: data,
    doc: creditCertificateData
  });
  return result;
}


export async function deleteCreditCertificate(app, id) {
  return await apiCommon.deleteDoc(app, {
    id,
    docType: CREDIT_CERTIFICATE
  });
}
